export const checkDepsChanged = (oldDeps?: unknown[], newDeps?: unknown[]) => {
  if (!oldDeps?.length && !newDeps?.length) {
    return false
  }
  if (oldDeps?.length !== newDeps?.length) {
    return true
  }

  const difference = oldDeps?.filter((el, index) => {
    return newDeps![index] !== el
  })
  return !!difference?.length
}
